export default "__VITE_ASSET__PBsgGDrE__"